























import { Component, Vue, Watch } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import ThirdPartyAccessManagementTab from './ThirdPartyAccessManagement.tab.vue';
import FHIRAccessManagementTab from './FHIRAccessManagement.tab.vue';
import { isUserAllowed } from '@/utils/rbac.util';
import { PermissionsMatrixActionsEnum } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';

const tabs = [
  {
    tab: 'Basic Authentication',
    groupname: '',
    limit: '50',
    page: '1',
    sortColumn: 'username',
    sortOrder: 'ASC'
  },
  {
    tab: 'FHIR APIs',
    groupname: '',
    limit: '50',
    page: '1',
    sortColumn: 'clientName',
    sortOrder: 'ASC'
  }
];

@Component({
  components: {
    Container,
    ThirdPartyAccessManagementTab,
    FHIRAccessManagementTab
  }
})
export default class AdminThirdPartyManagement extends Vue {
  public activeTab = 0;

  public get canViewBasicAuth(): boolean {
    return isUserAllowed(
      PermissionsMatrixActionsEnum.READ,
      'third_party_access_management-read'
    );
  }

  public get canViewFHIR(): boolean {
    return isUserAllowed(
      PermissionsMatrixActionsEnum.READ,
      'third_party_access_management-fhir-read'
    );
  }

  // Hidden tabs (v-if) are absent from b-tabs' children, so indices here must match what's actually rendered
  public get visibleTabs() {
    return tabs.filter((_, index) =>
      index === 0 ? this.canViewBasicAuth : this.canViewFHIR
    );
  }

  public mounted() {
    if (this.$route.query.tab) {
      const index = this.visibleTabs.findIndex(
        (res) => res.tab === this.$route.query.tab
      );

      if (index >= 0) {
        this.activeTab = index;
      }
    }
  }

  @Watch('activeTab')
  public onTabChange(value: number) {
    const tab = this.visibleTabs[value];
    if (!tab || this.$route.query.tab === tab.tab) {
      return;
    }

    this.$router.push({
      query: {
        ...(tab as { [key: string]: any })
      }
    });
  }
}
